<template>
  <Breadcrumb></Breadcrumb>
  <PhysicalPersonForm :physicalPerson="physicalPerson" :title="$gettext('Editer un client')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";
import { useRouter } from "vue-router";
import PhysicalPersonForm from "@/components/physical-persons/PhysicalPersonForm.vue";
import { usePhysicalPersonStore } from "@/stores/physicalPerson";
import { onMounted, ref } from "vue";

const router = useRouter();
const physicalPersonStore = usePhysicalPersonStore();
const physicalPerson = ref();

const onSubmit = (payload, actions) => {
  physicalPersonStore.savePhysicalPerson(payload, () => {
    router.push({ path: "/customers" });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

onMounted(async () => {
  physicalPerson.value = await physicalPersonStore.fetchPhysicalPerson(
    router.currentRoute.value.params.id,
    null,
    ["physicalPersonDocuments"]
  );
});

</script>
